import React from 'react'
import $ from 'jquery'
import { render } from 'react-dom'
import './quotes.scss'
import Quotes from './Quotes'

window.ActivateQuotes = (el = $('.quotes-widget')) => {
  const quotes = []
  $(el).find('.quotes-widget__quote')
    .each((i, quote) => {
      const content = $(quote).find('.quotes-widget__quote-content').text()
      let q = { content }
      let who = $(quote).find('.quotes-widget__quote-who')
      if (who.length === 1) {
        who = who.text()
        q = { ...q, who }
      }
      quotes.push(q)
    })

  el.empty()

  render(<Quotes quotes={quotes} />, el[0])
}
